var map = {
	"./": 240,
	"./App": 255,
	"./App.js": 255,
	"./components/autoComplete/autoComplete": 286,
	"./components/autoComplete/autoComplete.js": 286,
	"./components/autoComplete/style": 194,
	"./components/autoComplete/style.js": 194,
	"./components/buttons/buttons": 20,
	"./components/buttons/buttons.js": 20,
	"./components/buttons/calendar-button/calendar-button": 390,
	"./components/buttons/calendar-button/calendar-button.js": 390,
	"./components/buttons/export-button/export-button": 395,
	"./components/buttons/export-button/export-button.js": 395,
	"./components/buttons/share-button/share-button": 396,
	"./components/buttons/share-button/share-button.js": 396,
	"./components/buttons/styled": 222,
	"./components/buttons/styled.js": 222,
	"./components/canvas/canvas": 397,
	"./components/canvas/canvas.js": 397,
	"./components/cardTable/CardTable": 288,
	"./components/cardTable/CardTable.js": 288,
	"./components/cards/frame/cards-frame": 41,
	"./components/cards/frame/cards-frame.js": 41,
	"./components/cards/frame/style": 220,
	"./components/cards/frame/style.js": 220,
	"./components/cartList/cartList": 285,
	"./components/cartList/cartList.js": 285,
	"./components/category/products": 406,
	"./components/category/products.js": 406,
	"./components/category/style": 196,
	"./components/category/style.css": 407,
	"./components/category/style.js": 196,
	"./components/checkbox/checkbox": 408,
	"./components/checkbox/checkbox.js": 408,
	"./components/checkbox/style": 197,
	"./components/checkbox/style.js": 197,
	"./components/clientsTable/ClientsTable": 290,
	"./components/clientsTable/ClientsTable.js": 290,
	"./components/color-palette/palette": 223,
	"./components/color-palette/palette.js": 223,
	"./components/color-palette/style": 284,
	"./components/color-palette/style.js": 284,
	"./components/cortesTable/CortesTable": 291,
	"./components/cortesTable/CortesTable.js": 291,
	"./components/datePicker/datePicker": 287,
	"./components/datePicker/datePicker.js": 287,
	"./components/datePicker/style": 224,
	"./components/datePicker/style.js": 224,
	"./components/dropdown/dropdown": 283,
	"./components/dropdown/dropdown-style": 221,
	"./components/dropdown/dropdown-style.js": 221,
	"./components/dropdown/dropdown.js": 283,
	"./components/header-search/header-search": 275,
	"./components/header-search/header-search-style": 276,
	"./components/header-search/header-search-style.js": 276,
	"./components/header-search/header-search.js": 275,
	"./components/header/header": 410,
	"./components/header/header.js": 410,
	"./components/header/style": 292,
	"./components/header/style.js": 292,
	"./components/heading/heading": 38,
	"./components/heading/heading.js": 38,
	"./components/heading/style": 219,
	"./components/heading/style.js": 219,
	"./components/optionsTable/OptionsTable": 293,
	"./components/optionsTable/OptionsTable.js": 293,
	"./components/orderCard/orderCard": 186,
	"./components/orderCard/orderCard.js": 186,
	"./components/orderCard/style": 154,
	"./components/orderCard/style.js": 154,
	"./components/ordersTable/OrdersTable": 294,
	"./components/ordersTable/OrdersTable.js": 294,
	"./components/ordersView/orders-view": 412,
	"./components/ordersView/orders-view.js": 412,
	"./components/ordersView/style": 413,
	"./components/ordersView/style.js": 413,
	"./components/page-headers/page-headers": 58,
	"./components/page-headers/page-headers.js": 58,
	"./components/page-headers/style": 282,
	"./components/page-headers/style.js": 282,
	"./components/popup/popup": 68,
	"./components/popup/popup.js": 68,
	"./components/popup/style": 190,
	"./components/popup/style.css": 365,
	"./components/popup/style.js": 190,
	"./components/products/products": 414,
	"./components/products/products.js": 414,
	"./components/products/style": 198,
	"./components/products/style.css": 415,
	"./components/products/style.js": 198,
	"./components/productsTable/ProductsTable": 295,
	"./components/productsTable/ProductsTable.js": 295,
	"./components/rechargesTable/RechargesTable": 296,
	"./components/rechargesTable/RechargesTable.js": 296,
	"./components/summaryPayment/style": 289,
	"./components/summaryPayment/style.js": 289,
	"./components/summaryPayment/summaryPayment": 185,
	"./components/summaryPayment/summaryPayment.js": 185,
	"./components/usersTable/UsersTable": 297,
	"./components/usersTable/UsersTable.js": 297,
	"./components/utilities/SucursalGuard": 278,
	"./components/utilities/SucursalGuard.js": 278,
	"./components/utilities/auth-info/auth-info-style": 98,
	"./components/utilities/auth-info/auth-info-style.js": 98,
	"./components/utilities/auth-info/info": 218,
	"./components/utilities/auth-info/info.js": 218,
	"./components/utilities/auth-info/message": 416,
	"./components/utilities/auth-info/message.js": 416,
	"./components/utilities/auth-info/message/message": 417,
	"./components/utilities/auth-info/message/message.js": 417,
	"./components/utilities/auth-info/notification": 418,
	"./components/utilities/auth-info/notification.js": 418,
	"./components/utilities/auth-info/notification/notification": 419,
	"./components/utilities/auth-info/notification/notification.js": 419,
	"./components/utilities/auth-info/settings": 420,
	"./components/utilities/auth-info/settings.js": 420,
	"./components/utilities/auth-info/support": 421,
	"./components/utilities/auth-info/support.js": 421,
	"./components/utilities/protectedRoute": 281,
	"./components/utilities/protectedRoute.js": 281,
	"./components/utilities/utilities": 422,
	"./components/utilities/utilities.js": 422,
	"./config/api": 22,
	"./config/api/": 22,
	"./config/api/firebase": 423,
	"./config/api/firebase.js": 423,
	"./config/api/index": 22,
	"./config/api/index.js": 22,
	"./config/config": 108,
	"./config/config.js": 108,
	"./config/dataService/dataService": 23,
	"./config/dataService/dataService.js": 23,
	"./config/dataService/dataServicecard": 424,
	"./config/dataService/dataServicecard.js": 424,
	"./config/icon/icon": 425,
	"./config/icon/icon.json": 425,
	"./config/map/google-maps-styles": 426,
	"./config/map/google-maps-styles.js": 426,
	"./config/theme/themeVariables": 76,
	"./config/theme/themeVariables.js": 76,
	"./container/caja": 160,
	"./container/caja/": 160,
	"./container/caja/index": 160,
	"./container/caja/index.js": 160,
	"./container/caja/style": 427,
	"./container/caja/style.js": 427,
	"./container/card": 161,
	"./container/card/": 161,
	"./container/card/index": 161,
	"./container/card/index.js": 161,
	"./container/card/style": 428,
	"./container/card/style.js": 428,
	"./container/clientsHistory": 210,
	"./container/clientsHistory/": 210,
	"./container/clientsHistory/index": 210,
	"./container/clientsHistory/index.js": 210,
	"./container/clientsHistory/style": 429,
	"./container/clientsHistory/style.js": 429,
	"./container/configuration": 162,
	"./container/configuration/": 162,
	"./container/configuration/index": 162,
	"./container/configuration/index.js": 162,
	"./container/configuration/style": 430,
	"./container/configuration/style.js": 430,
	"./container/cortesHistory": 163,
	"./container/cortesHistory/": 163,
	"./container/cortesHistory/index": 163,
	"./container/cortesHistory/index.js": 163,
	"./container/cortesHistory/style": 431,
	"./container/cortesHistory/style.js": 431,
	"./container/dashboard": 164,
	"./container/dashboard/": 164,
	"./container/dashboard/index": 164,
	"./container/dashboard/index.js": 164,
	"./container/dashboard/style": 432,
	"./container/dashboard/style.js": 432,
	"./container/digitalCards": 211,
	"./container/digitalCards/": 211,
	"./container/digitalCards/index": 211,
	"./container/digitalCards/index.js": 211,
	"./container/digitalCards/style": 299,
	"./container/digitalCards/style.js": 299,
	"./container/orders": 165,
	"./container/orders/": 165,
	"./container/orders/index": 165,
	"./container/orders/index.js": 165,
	"./container/orders/style": 433,
	"./container/orders/style.js": 433,
	"./container/ordersHistory": 166,
	"./container/ordersHistory/": 166,
	"./container/ordersHistory/index": 166,
	"./container/ordersHistory/index.js": 166,
	"./container/ordersHistory/style": 434,
	"./container/ordersHistory/style.js": 434,
	"./container/pos": 157,
	"./container/pos/": 157,
	"./container/pos/index": 157,
	"./container/pos/index.js": 157,
	"./container/pos/style": 435,
	"./container/pos/style.js": 435,
	"./container/products": 212,
	"./container/products/": 212,
	"./container/products/index": 212,
	"./container/products/index.js": 212,
	"./container/products/style": 436,
	"./container/products/style.js": 436,
	"./container/profile/authentication/Index": 280,
	"./container/profile/authentication/Index.js": 280,
	"./container/profile/authentication/overview/SignIn": 345,
	"./container/profile/authentication/overview/SignIn.js": 345,
	"./container/profile/authentication/overview/style": 149,
	"./container/profile/authentication/overview/style.js": 149,
	"./container/rechargesHistory": 213,
	"./container/rechargesHistory/": 213,
	"./container/rechargesHistory/index": 213,
	"./container/rechargesHistory/index.js": 213,
	"./container/rechargesHistory/style": 437,
	"./container/rechargesHistory/style.js": 437,
	"./container/styled": 21,
	"./container/styled.js": 21,
	"./container/sucursalSelector": 214,
	"./container/sucursalSelector/": 214,
	"./container/sucursalSelector/index": 214,
	"./container/sucursalSelector/index.js": 214,
	"./container/sucursalSelector/style.css": 438,
	"./container/sucursales": 215,
	"./container/sucursales/": 215,
	"./container/sucursales/index": 215,
	"./container/sucursales/index.js": 215,
	"./container/users": 216,
	"./container/users/": 216,
	"./container/users/index": 216,
	"./container/users/index.js": 216,
	"./container/users/style": 439,
	"./container/users/style.js": 439,
	"./demoData/header-search": 178,
	"./demoData/header-search.json": 178,
	"./demoData/message-list": 87,
	"./demoData/message-list.json": 87,
	"./demoData/usersData": 440,
	"./demoData/usersData.json": 440,
	"./hooks/useChartData": 441,
	"./hooks/useChartData.js": 441,
	"./index": 240,
	"./index.js": 240,
	"./layout/MenueItems": 274,
	"./layout/MenueItems.js": 274,
	"./layout/TopMenu": 442,
	"./layout/TopMenu.js": 442,
	"./layout/style": 134,
	"./layout/style.js": 134,
	"./layout/withAdminLayout": 273,
	"./layout/withAdminLayout.js": 273,
	"./libs/StarWebPrintBuilder": 300,
	"./libs/StarWebPrintBuilder.js": 300,
	"./libs/StarWebPrintTrader": 301,
	"./libs/StarWebPrintTrader.js": 301,
	"./redux/authentication/actionCreator": 184,
	"./redux/authentication/actionCreator.js": 184,
	"./redux/authentication/actions": 170,
	"./redux/authentication/actions.js": 170,
	"./redux/authentication/reducers": 260,
	"./redux/authentication/reducers.js": 260,
	"./redux/cards/actionCreator": 99,
	"./redux/cards/actionCreator.js": 99,
	"./redux/cards/actions": 181,
	"./redux/cards/actions.js": 181,
	"./redux/cards/reducers": 217,
	"./redux/cards/reducers.js": 217,
	"./redux/clients/actionCreator": 131,
	"./redux/clients/actionCreator.js": 131,
	"./redux/clients/actions": 179,
	"./redux/clients/actions.js": 179,
	"./redux/clients/reducers": 268,
	"./redux/clients/reducers.js": 268,
	"./redux/cortes/actionCreator": 298,
	"./redux/cortes/actionCreator.js": 298,
	"./redux/cortes/actions": 174,
	"./redux/cortes/actions.js": 174,
	"./redux/cortes/reducers": 264,
	"./redux/cortes/reducers.js": 264,
	"./redux/digitalCards/actionCreator": 125,
	"./redux/digitalCards/actionCreator.js": 125,
	"./redux/digitalCards/actions": 183,
	"./redux/digitalCards/actions.js": 183,
	"./redux/digitalCards/reducers": 271,
	"./redux/digitalCards/reducers.js": 271,
	"./redux/headerSearch/actionCreator": 277,
	"./redux/headerSearch/actionCreator.js": 277,
	"./redux/headerSearch/actions": 177,
	"./redux/headerSearch/actions.js": 177,
	"./redux/headerSearch/reducers": 267,
	"./redux/headerSearch/reducers.js": 267,
	"./redux/message/actionCreator": 225,
	"./redux/message/actionCreator.js": 225,
	"./redux/message/actions": 168,
	"./redux/message/actions.js": 168,
	"./redux/message/reducers": 258,
	"./redux/message/reducers.js": 258,
	"./redux/notification/actionCreator": 226,
	"./redux/notification/actionCreator.js": 226,
	"./redux/notification/actions": 169,
	"./redux/notification/actions.js": 169,
	"./redux/notification/reducers": 259,
	"./redux/notification/reducers.js": 259,
	"./redux/orders/actionCreator": 104,
	"./redux/orders/actionCreator.js": 104,
	"./redux/orders/actions": 173,
	"./redux/orders/actions.js": 173,
	"./redux/orders/reducers": 263,
	"./redux/orders/reducers.js": 263,
	"./redux/pos/actionCreator": 153,
	"./redux/pos/actionCreator.js": 153,
	"./redux/pos/actions": 172,
	"./redux/pos/actions.js": 172,
	"./redux/pos/reducers": 262,
	"./redux/pos/reducers.js": 262,
	"./redux/products/actionCreator": 85,
	"./redux/products/actionCreator.js": 85,
	"./redux/products/actions": 180,
	"./redux/products/actions.js": 180,
	"./redux/products/reducers": 269,
	"./redux/products/reducers.js": 269,
	"./redux/recharges/actionCreator": 227,
	"./redux/recharges/actionCreator.js": 227,
	"./redux/recharges/actions": 182,
	"./redux/recharges/actions.js": 182,
	"./redux/recharges/reducers": 270,
	"./redux/recharges/reducers.js": 270,
	"./redux/rootReducers": 257,
	"./redux/rootReducers.js": 257,
	"./redux/store": 256,
	"./redux/store.js": 256,
	"./redux/sucursal/actionCreator": 84,
	"./redux/sucursal/actionCreator.js": 84,
	"./redux/sucursal/actions": 171,
	"./redux/sucursal/actions.js": 171,
	"./redux/sucursal/reducers": 261,
	"./redux/sucursal/reducers.js": 261,
	"./redux/themeLayout/actionCreator": 443,
	"./redux/themeLayout/actionCreator.js": 443,
	"./redux/themeLayout/actions": 175,
	"./redux/themeLayout/actions.js": 175,
	"./redux/themeLayout/reducers": 265,
	"./redux/themeLayout/reducers.js": 265,
	"./redux/users/actionCreator": 123,
	"./redux/users/actionCreator.js": 123,
	"./redux/users/actions": 176,
	"./redux/users/actions.js": 176,
	"./redux/users/reducers": 266,
	"./redux/users/reducers.js": 266,
	"./routes/admin": 167,
	"./routes/admin/": 167,
	"./routes/admin/dashboard": 272,
	"./routes/admin/dashboard.js": 272,
	"./routes/admin/index": 167,
	"./routes/admin/index.js": 167,
	"./routes/auth": 279,
	"./routes/auth.js": 279,
	"./serviceWorker": 302,
	"./serviceWorker.js": 302,
	"./static/cert/certificate": 444,
	"./static/cert/certificate.js": 444,
	"./static/cert/private": 303,
	"./static/cert/private.js": 303,
	"./static/css/style.css": 387,
	"./static/img/Logo_Dark.png": 381,
	"./static/img/Logo_white.png": 382,
	"./static/img/auth/BG.png": 383,
	"./static/img/auth/Illustration.png": 386,
	"./static/img/auth/Illustration2.png": 725,
	"./static/img/auth/bottomShape.png": 385,
	"./static/img/auth/topShape.png": 384,
	"./static/img/avatar/NoPath (2).png": 726,
	"./static/img/avatar/NoPath (3).png": 727,
	"./static/img/avatar/NoPath (4).png": 728,
	"./static/img/avatar/NoPath.png": 159,
	"./static/img/avatar/chat-auth.png": 333,
	"./static/img/avatar/profileImage.png": 729,
	"./static/img/avatar/t1.png": 730,
	"./static/img/avatar/team-1.png": 731,
	"./static/img/flag/english.png": 732,
	"./static/img/flag/germany.png": 733,
	"./static/img/flag/spain.png": 734,
	"./static/img/flag/turky.png": 735,
	"./static/img/google.png": 736,
	"./static/img/icon/007-microphone-1.png": 335,
	"./static/img/icon/010-home.png": 336,
	"./static/img/icon/013-document-1.png": 337,
	"./static/img/icon/014-document.png": 338,
	"./static/img/icon/015-color-palette.png": 339,
	"./static/img/icon/017-video-camera.png": 340,
	"./static/img/icon/image.png": 377,
	"./static/img/icon/label.png": 378,
	"./static/img/icon/left.svg": 379,
	"./static/img/icon/right.svg": 380,
	"./static/img/latidoLogo.png": 737,
	"./static/img/products/1.png": 738,
	"./static/img/products/2.png": 739,
	"./utility/latidoBase64": 304,
	"./utility/latidoBase64.js": 304,
	"./utility/localStorageControl": 75,
	"./utility/localStorageControl.js": 75,
	"./utility/printerUtils": 445,
	"./utility/printerUtils.js": 445,
	"./utility/printerUtilsQZ": 446,
	"./utility/printerUtilsQZ.js": 446,
	"./utility/utility": 65,
	"./utility/utility.js": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;